import { render, staticRenderFns } from "./superSet.vue?vue&type=template&id=6aad20e4&scoped=true"
import script from "./superSet.vue?vue&type=script&lang=js"
export * from "./superSet.vue?vue&type=script&lang=js"
import style0 from "./superSet.vue?vue&type=style&index=0&id=6aad20e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aad20e4",
  null
  
)

export default component.exports